<template>
  <container 
    subHeaderTitle="세이프가드·금융사기방지"
    subHeaderText="안전한 금융 거래를 위해 국내 모든 금융기관을 모니터링하고, 알람을 제공하며, <br class='br' />금융사기(보이스피싱, 해킹 등)로 인한 금전손실 발생 시 보상을 제공합니다."
    subHeaderImage="logo_pass.svg" 
    subHeaderColor
  >
    <section class="service-top">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="service-top-bg sevice-safegaurd">
            <div class="py-0 d-sm-flex align-center">
              <div class="full-width">
                <p class="text-title">나의 금융 거래를<br /><b>더 안전하게!</b></p>
                <p class="text-content">고객님의 금융 정보를 365일 24시간 모니터링하고,<br />의심스러운 금융 거래와 금융 사고로부터 보호합니다.<br />금전적 손실 발생 시, 200만원까지 보상을 제공합니다.</p>
                <v-btn depressed rounded x-large color="#647CF2" @click.stop="moveContract" :data-ga-category="gaEvent.category.service.safeguard.name" :data-ga-label="gaEvent.category.service.safeguard.label1" :data-ga-action="gaEvent.actions.buttonClick">안전하게 보호하기</v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="service-center">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <v-row>
              <v-col cols="12" sm="6" class="py-0 d-flex align-center">
                <img ref="serviceImage" class="service-center-img" src="@/assets/new/image/service/service_safeguard_center.svg" alt="">
              </v-col>
              <v-col cols="12" sm="6" class="py-0 d-flex flex-column justify-center">
                <div class="service-center-title">
                  <h1>미확인 금융기관 조회 이력을 <br class="br-m" />지금 확인하세요!</h1>
                  <p>금융 사기가 의심스러운 금융 거래 내역을 확인하고, 금융사기를 예방하세요.</p>
                </div>
                <div class="service-center-list">
                  <div class="icon">
                    <img src="@/assets/new/image/service/service_safeguard_icon_1.svg" alt="">
                  </div>
                  <div class="copy">
                    <p class="text-content">은행, 카드사, 증권사, 보험, 대부업 등</p>
                    <p class="text-title">실시간 모니터링 및 알림 제공</p>
                  </div>
                </div>
                <div class="service-center-list">
                  <div class="icon">
                    <img src="@/assets/new/image/service/service_safeguard_icon_2.svg" alt="">
                  </div>
                  <div class="copy">
                    <p class="text-content">의심스러운 금융 거래</p>
                    <p class="text-title">250여개 금융기관 신고센터와 <br class="br-m" />즉시 연결</p>
                  </div>
                </div>
                <div class="service-center-list">
                  <div class="icon">
                    <img src="@/assets/new/image/service/service_safeguard_icon_3.svg" alt="">
                  </div>
                  <div class="copy">
                    <p class="text-content">금융 사기로 금전적인 손실 발생 시</p>
                    <p class="text-title">200만원 한도 보상<span>(발생 손실액 기준)</span></p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="service-end">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <v-row>
              <v-col cols="12" sm="4" class="py-0">
                <p class="text-title">최근 금융기관 조회 이력</p>
                <p class="text-content">국내 주요 금융기관에서 이용한 휴대폰 본인확인<br />이용 기록 통계를 기반으로 제공됩니다.</p>
                <div class="service-end-img">
                  <img ref="serviceImg1" src="@/assets/new/image/service/service_safeguard_end_1.png" alt="">
                </div>
                <p class="text-content">세이프가드(SKT)</p>
              </v-col>
              <v-col cols="12" sm="4" class="py-0">
                <p class="text-title">나의 온라인 금융 거래</p>
                <p class="text-content">인증 이력을 토대로 금융거래 활성화 지수를<br />제공해 드립니다. (매일 업데이트)</p>
                <div class="service-end-img">
                  <img ref="serviceImg2" src="@/assets/new/image/service/service_safeguard_end_2.png" alt="">
                </div>
                <p class="text-content">세이프가드(KT)</p>
              </v-col>
              <v-col cols="12" sm="4" class="py-0">
                <p class="text-title">주의 거래 모니터링</p>
                <p class="text-content">심야 거래, 정보 변경 거래 이력 또한<br />모니터링하여 제공합니다.</p>
                <div class="service-end-img">
                  <img ref="serviceImg3" src="@/assets/new/image/service/service_safeguard_end_3.png" alt="">
                </div>
                <p class="text-content">금융사기방지(LGU+)</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </container>
</template>

<script>
import Container from "@/pages/container/index.vue";
import {GaTracking} from "@/mixins/index.js";

export default {
  mixins: [GaTracking],
  name: "SafeGuard",
  components: {
    Container,
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    getImageHeight() {
      this.$refs.serviceImage.style.height = Math.ceil(this.$refs.serviceImage.clientWidth) + "px"
      this.$refs.serviceImg1.style.height = Math.ceil(this.$refs.serviceImg1.clientWidth * 1.6) + "px"
      this.$refs.serviceImg2.style.height = Math.ceil(this.$refs.serviceImg2.clientWidth * 1.6) + "px"
      this.$refs.serviceImg3.style.height = Math.ceil(this.$refs.serviceImg3.clientWidth * 1.6) + "px"
    },
    moveContract(e){
      this.gaTracking(e);
      this.$router.push({name: 'PassSafeguardContract'});
    },
  },
  created() {
    window.addEventListener('resize', () => {
      this.getImageHeight();
    })
  },
  mounted() {
    this.getImageHeight();
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.getImageHeight();
    })
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/service";
</style>